@import '../styles/fonts.scss';
@import '../styles/palette.scss';

.verticalMargin {
  margin: 20px 0;
}

.smallInput {
  max-width: 100px;
}

.klasseAndPeriodeInput {
  max-width: 26ch;
}

.smallInputNumber {
  max-width: 110px;
}

.praksisklasseChanged {
  @include barlowMedium(14);
  color: _palette(warning-1);
}

.copyIconBtn {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
  padding-bottom: 0.125em;
}

.copyModal {
  width: 60%;

  .header {
    margin-top: 0.5em;
  }

  .modalSelectPeriode {
    display: flex;
    margin-bottom: 0.5em;

    .dateInput {
      margin-left: 0.5em;
    }
  }

  .modalCheckboxes {
    display: inline-flex;

    & * {
      margin-top: 0.25rem;
      margin-bottom: 0.25rem;
    }
  }

  .overlapWarning {
    @include barlowMedium(14);
    min-height: 1.42em;
    margin: 0.25em 0;
  }
}

.fritekst {
  width: 100%;
  min-height: 15em;
  resize: vertical;
  margin-bottom: 1em;
}

.fsStatus {
  color: _palette(text-white);

  &.ok {
    background: darkgreen;
  }

  &.error {
    background: _palette(text-red);
  }
}
